import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbAgentTypes } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-agent-type-picker',
    templateUrl: './agent-type-picker.component.html',
    styleUrls: ['./agent-type-picker.component.scss'],
})
export class AgentTypePickerComponent {

    @Input()
    public selectedItem: string;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public agentTypes: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor(private translateService: TranslateService) {
        this.translateService.get('agentTypes').subscribe(labels => {
            for (const em in OcbAgentTypes) {
                if (isNaN(Number(em))) {
                    this.agentTypes.push({ name: labels[em], id: OcbAgentTypes[em] });
                }
            }
            this.loading = false;
        });
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event.id);
    }
}
